module.exports = __webpack_public_path__ + "static/img/e802881e.svg";